import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-cmd-fourn',
  templateUrl: './brouillon-cmd-fourn.component.html',
  styleUrls: ['./brouillon-cmd-fourn.component.scss']
})
export class BrouillonCmdFournComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Brouillon');
    }

}
